'use strict';

angular.module('inara').filter('callTimerFilter', function() {
    return function (ms) {
    	if (!angular.isDefined(ms) ||
            ms < 0) {
    		return "0:00";
    	}

        var numSeconds = Math.floor(ms / 1000);
        var hours = Math.floor(numSeconds / 3600);
        var minutes = Math.floor((numSeconds - hours * 3600) / 60);
        var seconds = numSeconds - hours * 3600 - minutes * 60;

        if (minutes < 10 && hours > 0) {
            minutes = '0' + minutes;
        }
        if (seconds < 10) {
            seconds = '0' + seconds;
        }
        var time = (hours > 0 ? hours + ':' : '') + minutes + ':' + seconds;
        return time;
    };
});
